export default {
  common: {
    email: 'E-mail',
    emailPlaceholder: "vas{'@'}email.cz",
    password: 'Heslo',
    showPassword: 'Zobrazit heslo',
    hidePassword: 'Skrýt heslo',
    or: 'Nebo',
  },
  login: {
    pageTitle: 'Přihlášení',
    cardTitlePrefix: 'Přihlásit',
    cardTitleAccent: 'se',
    subtitle: 'Vítejte zpět. Přihlaste se a pokračujte.',
    forgotPassword: 'Zapomenuté heslo?',
    submit: 'Přihlásit se',
    submitting: 'Přihlašování…',
    noAccount: 'Nemáte účet?',
    signUp: 'Registrovat se',
    invalidCredentials: 'Nesprávný e-mail nebo heslo.',
    sessionExpired: 'Vaše relace vypršela. Přihlaste se prosím znovu.',
  },
  register: {
    pageTitle: 'Registrace',
    cardTitlePrefix: 'Vytvořit',
    cardTitleAccent: 'účet',
    subtitle: 'Zaregistrujte se a začněte sbírat klíče ke hrám.',
    passwordHint: 'Minimálně 8 znaků',
    agreePrefix: 'Souhlasím s',
    terms: 'obchodními podmínkami',
    and: 'a',
    privacy: 'zásadami ochrany osobních údajů',
    submit: 'Vytvořit účet',
    submitting: 'Vytváření účtu…',
    haveAccount: 'Už máte účet?',
    logIn: 'Přihlásit se',
    acceptTerms: 'Pro pokračování prosím odsouhlaste obchodní podmínky.',
    passwordTooShort: 'Heslo musí mít alespoň 8 znaků.',
    createFailed: 'Účet se nepodařilo vytvořit. Zkuste jiný e-mail.',
  },
  reset: {
    pageTitle: 'Obnovení hesla',
    backToLogin: 'Zpět na přihlášení',
    cardTitle: 'Obnovit heslo',
    cardTitlePrefix: 'Obnovit',
    cardTitleAccent: 'heslo',
    description: 'Zadejte svou e-mailovou adresu a my vám pošleme pokyny k obnovení hesla.',
    submit: 'Odeslat pokyny',
    submitting: 'Odesílání…',
    genericError: 'Něco se pokazilo. Zkuste to prosím znovu.',
    sentTitle: 'Zkontrolujte svůj e-mail',
    sentText: 'Pokyny k obnovení hesla jsme odeslali na adresu {email}',
  },
  twofa: {
    stepTitlePrefix: 'Dvoufázové',
    stepTitleAccent: 'ověření',
    stepTotpHint: 'Zadejte 6místný kód z autentizační aplikace.',
    stepEmailHint: 'Poslali jsme vám 6místný kód e-mailem. Zadejte jej níže.',
    verify: 'Ověřit',
    verifying: 'Ověřování…',
    resend: 'Poslat kód znovu',
    resent: 'Kód odeslán ✓',
    invalidCode: 'Neplatný nebo vypršelý kód.',
    title: 'Dvoufázové ověření',
    description: 'Přidejte druhý krok při přihlášení pro lepší zabezpečení účtu.',
    statusEnabled: 'Zapnuto',
    statusDisabled: 'Vypnuto',
    methodTotp: 'Autentizační aplikace',
    methodTotpDesc: 'Použijte Google Authenticator, Authy, 1Password apod.',
    methodEmail: 'E-mail',
    methodEmailDesc: 'Získejte jednorázový kód e-mailem při každém přihlášení.',
    chooseMethod: 'Vyberte metodu',
    setUp: 'Nastavit',
    scanQr: 'Naskenujte QR kód autentizační aplikací a zadejte 6místný kód.',
    orEnterKey: 'Nebo zadejte tento klíč ručně:',
    emailCodeSent: 'Poslali jsme vám 6místný kód e-mailem. Zadejte jej pro potvrzení.',
    enterCode: 'Ověřovací kód',
    enable: 'Zapnout',
    enabling: 'Zapínání…',
    cancel: 'Zrušit',
    disable: 'Vypnout',
    disabling: 'Vypínání…',
    disableTotpHint: 'Zadejte aktuální kód z autentizační aplikace pro vypnutí 2FA.',
    disableEmailHint: 'Pošlete si kód a zadejte jej pro vypnutí 2FA.',
    sendCode: 'Poslat kód',
    codeSent: 'Kód odeslán',
    enableFailed: 'Nepodařilo se zapnout. Zkontrolujte kód a zkuste to znovu.',
    disableFailed: 'Nepodařilo se vypnout. Zkontrolujte kód a zkuste to znovu.',
    enabledVia: 'Aktivní přes {method}',
  },
  verify: {
    pageTitle: 'Ověření e-mailu',
    verifyingTitle: 'Ověřování…',
    verifyingText: 'Potvrzujeme vaši e-mailovou adresu.',
    successTitle: 'E-mail ověřen',
    successTitlePrefix: 'E-mail',
    successTitleAccent: 'ověřen',
    successText: 'Vaše e-mailová adresa byla úspěšně ověřena. Nyní máte přístup ke všem funkcím.',
    goToDashboard: 'Přejít na nástěnku',
    failedTitle: 'Ověření se nezdařilo',
    failedTitlePrefix: 'Ověření',
    failedTitleAccent: 'selhalo',
    resendEmail: 'Odeslat e-mail znovu',
    invalidLink: 'Tento ověřovací odkaz je neplatný nebo vypršela jeho platnost.',
    noToken: 'Nebyl poskytnut žádný ověřovací token.',
  },
};
